import { ReactNode } from "react";

import { RVHighlightedString } from "@regal-voice/ui";

import styles from "./RVEventSchemaOption.module.scss";

export function RVEventSchemaOption({
    val,
    highlightVal,
    hideTypeLabel,
    valType,
}: {
    val: string;
    highlightVal?: string;
    hideTypeLabel?: boolean;
    valType: string;
}): JSX.Element {
    return (
        <span className={styles.eventSchemaOptionContainer} key={`event-schema-option-${val}`}>
            <RVHighlightedString val={val} highlightVal={highlightVal} />
            {!hideTypeLabel && <span className={styles.typeMetaInfo}>Data Type: {valType} </span>}
        </span>
    );
}

export type RVEventSchemaOption = {
    value: string;
    label: ReactNode;
    dataType: string;
};

/**
 * Creates an option from schema entries for the typeahead select.
 */
export function createSchemaOption(
    label: string,
    value: string,
    optionFieldType: string,
    highlightString?: string,
    hideTypeLabel?: boolean
): RVEventSchemaOption {
    return {
        value,
        label: (
            <RVEventSchemaOption
                val={label}
                highlightVal={highlightString}
                hideTypeLabel={hideTypeLabel}
                valType={optionFieldType}
            />
        ),
        dataType: optionFieldType,
    };
}
